import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { operationsService, Method, OperationsData } from '../../services/api/operationsService';

interface OperationsState {
  rechargeMethods: Method[];
  packetMethods: Method[];
  invoiceMethods: Method[];
  insuranceMethods: Method[];
  isLoading: boolean;
  error: string | null;
}

const initialState: OperationsState = {
  rechargeMethods: [],
  packetMethods: [],
  invoiceMethods: [],
  insuranceMethods: [],
  isLoading: false,
  error: null
};

// Acción asíncrona para cargar los datos de operaciones
export const fetchOperationsData = createAsyncThunk<OperationsData, void>(
  'operations/fetchData',
  async (_, { rejectWithValue }) => {
    try {
      const response = await operationsService.getOperationsData();
      
      if (!response.success) {
        return rejectWithValue(response.message || 'Error al obtener datos de operaciones');
      }
      
      return response.data as OperationsData;
    } catch (error: any) {
      if (error.message) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue('Error al conectar con el servidor');
    }
  }
);

const operationsSlice = createSlice({
  name: 'operations',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    // Cargar datos de operaciones
    builder.addCase(fetchOperationsData.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchOperationsData.fulfilled, (state, action: PayloadAction<OperationsData>) => {
      state.isLoading = false;
      state.rechargeMethods = action.payload.rechargeMethods;
      state.packetMethods = action.payload.packetMethods;
      state.invoiceMethods = action.payload.invoiceMethods;
      state.insuranceMethods = action.payload.insuranceMethods;
    });
    builder.addCase(fetchOperationsData.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload as string;
    });
  }
});

export const { clearError } = operationsSlice.actions;

export default operationsSlice.reducer;
